import * as yup from 'yup';
import i18n from 'i18next';

export const ResetPasswordSchema = yup.object({
  recoveryToken: yup.string().required(i18n.t('required', { ns: 'common' })),
  newPassword: yup.string().required(i18n.t('required', { ns: 'common' })),
});
